import {
  tripodGetRequest,
  tripodPostRequest,
  tripodPutRequest,
  tripodDeleteRequest
} from "../dataProvider";

export default class TripodUtilService {
  async get(api, config) {
    let response = await tripodGetRequest(api, config);
    return response;
  }
  async post(api, data, config) {
    let response = await tripodPostRequest(api, data, config);
    return response;
  }
  async put(api, data, config) {
    let response = await tripodPutRequest(api, data, config);
    return response;
  }
  async delete(api, config) {
    let response = await tripodDeleteRequest(api, config);
    return response;
  }
}
